import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Layout } from 'antd';
import AppHeader from '../Header';
const { Content } = Layout;

export const ProtectedLayout = () => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" />;
  }

  return (
    <Layout style={{ width: '100%', minHeight: '100vh' }}>
      <AppHeader />
      <Content
        style={{
          margin: '24px 16px 0',
          padding: '1rem',
          backgroundColor: 'white',
        }}
      >
        <Outlet />
      </Content>
    </Layout>
  );
};
